import React, { Component } from "react";
import { connect } from "react-redux";
import { setFiles } from '../actions';
import ReactNotify from "react-notify";
import SearchRutForm from "../components/SearchRutForm.jsx";
import FilesPermsList from "../components/FilesPermsList.jsx";
import { getFilesByRut } from '../services/collectivePermissionService.js';
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'

class CollectivePermission extends Component {
    constructor(props){
        super(props)
        this.state = {};
        
        this.ajaxErrorHandler = (errorTitle) => {
            return (err)=>{
                if(err.status == 500)
                    return this.refs.notificator.error("Lo sentimos ocurrió un error inesperado.", 4*1000);
                let msgs = _.values(err.data).join('. ');
                console.log(err);
                console.log(errorTitle, err.data);
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        };
        
        this.getFiles = (rut) => {
            return getFilesByRut(rut)
                .then(res => {
                    const response = res.data;
                    this.props.setFiles(response.files);

                })
                .catch(this.ajaxErrorHandler('Búsqueda de personal'))
        }
        
    }
    
    render(){
        return (
            <div className="container">
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <SearchRutForm getFiles={this.getFiles} />
                <FilesPermsList files={this.props.files}/>
            </div>
        )
    }
}

const mapDispatchToProps = {
    setFiles
};

const mapStateToProps = (state) => {
    return {
        files: state.filesState.files
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectivePermission);


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/containers/CollectivePermission.jsx